"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19 11h-8v6h8zm4 10V3H1v18zm-2-1.98H3V4.97h18z"
}), 'PictureInPictureAltSharp');